module.exports = __webpack_public_path__ + "static/media/money.22757377.svg";